import { render, staticRenderFns } from "./PendingCompletedTasksFilter.vue?vue&type=template&id=987b95b4&scoped=true&"
import script from "./PendingCompletedTasksFilter.vue?vue&type=script&lang=js&"
export * from "./PendingCompletedTasksFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987b95b4",
  null
  
)

export default component.exports